<template>
    <div id="ComponentModalItem">
        <div class="modal fade modern-modal" id="ModalItem" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-grande">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>
                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Cadastro de Itens</h2>
                            <p>Cadastre, importe ou atualize os itens e lotes associados ao processo atual.</p>
                        </div>
                        <div class="header-actions" v-if="!modoVisualizacao">
                            <button class="modern-btn modern-btn-secondary"
                                    type="button"
                                    @click="exportarExcel"
                                    title="Exportar itens em Excel">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 24 24" fill="currentColor">
                                    <title>file-export-outline</title>
                                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2M18 20H6V4H13V9H18V20M16 11V18.1L13.9 16L11.1 18.8L8.3 16L11.1 13.2L8.9 11H16Z" />
                                </svg>
                                Exportar Excel
                            </button>
                            <button class="modern-btn modern-btn-primary" type="button" @click="abrirCadastroItem">
                                + Novo item
                            </button>
                            <button class="modern-btn modern-btn-success" @click="importacaoItens">
                                <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" fill="currentColor" viewBox="0 0 24 24">
                                    <path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M15 11.93V19H7.93L10.05 16.88L7.22 14.05L10.05 11.22L12.88 14.05L15 11.93Z" />
                                </svg>
                                Importar itens
                            </button>
                        </div>
                    </div>
                    <div class="modal-modern-body">
                        <transition name="fade-slide">
                            <div class="form-section" v-if="mostrarCadastroItem && !modoVisualizacao">
                                <!-- Origem do item (melhor UI) -->
                                <div class="origin-block mb-3" v-if="!modoEdicao">
                                    <div class="origin-top">
                                        <div>
                                            <label class="form-label mb-1">Origem do item</label>
                                            <div class="origin-sub">
                                                <span v-if="modoOrigemItem === 'NOVO'">Você vai cadastrar um novo item no catálogo.</span>
                                                <span v-else>Você vai selecionar um item já existente no catálogo.</span>
                                            </div>
                                        </div>

                                        <div class="origin-switch">
                                            <button type="button"
                                                    class="origin-btn"
                                                    :class="{ active: modoOrigemItem === 'NOVO' }"
                                                    @click="modoOrigemItem = 'NOVO'">
                                                Novo item
                                            </button>

                                            <button type="button"
                                                    class="origin-btn"
                                                    :class="{ active: modoOrigemItem === 'CATALOGO' }"
                                                    @click="modoOrigemItem = 'CATALOGO'">
                                                Catálogo
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <!-- Painel Catálogo -->
                                <transition name="fade-slide">
                                    <div v-if="modoOrigemItem === 'CATALOGO' && !modoEdicao" class="catalog-panel mb-4">
                                        <div class="form-group mb-2">
                                            <label class="form-label">Buscar item do catálogo (por nome)</label>

                                            <v-select v-model="itemCatalogoSelecionado"
                                                      :options="listaItensCatalogo"
                                                      :filterable="false"
                                                      :clearable="true"
                                                      :loading="buscandoCatalogo"
                                                      @search="onSearchCatalogo"
                                                      @input="onSelectCatalogoItem"
                                                      :get-option-label="getLabelCatalogo"
                                                      placeholder="Digite ao menos 3 caracteres...">
                                                <template #no-options>
                                                    <span>Digite ao menos 3 caracteres.</span>
                                                </template>
                                            </v-select>
                                        </div>

                                        <small class="text-muted">
                                            Ao selecionar, Nome/Código/Referência/Tipo serão preenchidos automaticamente.
                                        </small>
                                    </div>
                                </transition>

                                <div class="section-header">
                                    <h4>{{ modoEdicao ? 'Editar item do processo' : 'Informações do item' }}</h4>
                                    <p v-if="modoEdicao">Altere apenas a unidade de medida, a quantidade e o valor unitário.</p>
                                    <p v-else>Preencha os campos obrigatórios para cadastrar um novo item ou atualizar um existente.</p>
                                </div>
                                <div class="form-columns">
                                    <div class="form-column">
                                        <div class="form-group">
                                            <label class="form-label">Nome do Item</label>
                                            <input type="text"
                                                   v-model="item.nome"
                                                   :disabled="bloqueiaIdentificacaoItem"
                                                   class="form-control"
                                                   :class="{ 'campo-bloqueado': bloqueiaIdentificacaoItem, 'border-danger': camposInvalidosItem.nome }"
                                                   placeholder="Ex: Parafuso galvanizado"
                                                   maxlength="3000" />
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label class="form-label">Tipo de Item</label>
                                                <select class="form-control"
                                                        v-model="item.tpItem"
                                                        :disabled="bloqueiaIdentificacaoItem"
                                                        :class="{ 'campo-bloqueado': bloqueiaIdentificacaoItem, 'border-danger': camposInvalidosItem.tpItem }">
                                                    <option disabled value="">Selecione</option>
                                                    <option value="M">Material</option>
                                                    <option value="S">Serviço</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Unidade de Medida</label>
                                                <div class="input-with-action">
                                                    <v-select v-model="unidadeSelecionada"
                                                              class="unidade-select"
                                                              :class="{ 'select-invalid': camposInvalidosItem.unidadeSelecionada }"
                                                              :options="unidadesMedida"
                                                              :reduce="um => um.idUnidadeMedida"
                                                              :get-option-label="formatarUnidade"
                                                              :filterable="true"
                                                              :clearable="false"
                                                              placeholder="Selecione ou digite para filtrar">
                                                        <template #no-options>
                                                            <span>Nenhuma unidade encontrada.</span>
                                                        </template>
                                                    </v-select>
                                                    <button class="modern-icon-btn" type="button" @click="abrirModalNovaUnidade" title="Cadastrar nova unidade">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4Z" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="form-group" v-if="unidadeExigePeriodicidade">
                                                <label class="form-label">Periodicidade</label>
                                                <select class="form-control"
                                                        v-model="periodicidadeSelecionada"
                                                        :class="{ 'border-danger': camposInvalidosItem.periodicidadeSelecionada }">
                                                    <option disabled value="">Selecione</option>
                                                    <option v-for="p in periodicidades" :key="p.idPeriodicidade" :value="p.idPeriodicidade">
                                                        {{ formatarPeriodicidade(p) }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-column">
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label class="form-label">Código</label>
                                                <input type="text"
                                                       v-model="item.codigo"
                                                       inputmode="numeric"
                                                       pattern="[0-9]*"
                                                       maxlength="100"
                                                       @input="onCdItemInput"
                                                       :disabled="bloqueiaIdentificacaoItem"
                                                       :class="{ 'campo-bloqueado': bloqueiaIdentificacaoItem, 'border-danger': camposInvalidosItem.codigo }"
                                                       class="form-control"
                                                       placeholder="Informe o código único do item" />
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Referência</label>
                                                <input type="text"
                                                       v-model="item.referencia"
                                                       :disabled="bloqueiaIdentificacaoItem"
                                                       placeholder="Ex: 0003"
                                                       class="form-control"
                                                       :class="{ 'campo-bloqueado': bloqueiaIdentificacaoItem }"
                                                       maxlength="150" />
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group">
                                                <label class="form-label">Quantidade</label>
                                                <input type="number"
                                                       step="0.01"
                                                       v-model.number="item.quantidade"
                                                       placeholder="0"
                                                       class="form-control"
                                                       :class="{ 'border-danger': camposInvalidosItem.quantidade }"
                                                       @input="calcularTotal" />
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Valor Unitário</label>
                                                <div class="input-group modern-input-group">
                                                    <span class="input-group-text">R$</span>
                                                    <input type="text"
                                                           class="form-control"
                                                           placeholder="0,00"
                                                           :class="{ 'border-danger': camposInvalidosItem.valorUnitario }"
                                                           v-model="item.valorUnitarioFormatado"
                                                           @input="formatarValorUnitario" />
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Valor Total</label>
                                                <div class="input-group modern-input-group">
                                                    <span class="input-group-text">R$</span>
                                                    <input type="text"
                                                           v-model="item.valorTotal"
                                                           class="form-control campo-bloqueado"
                                                           disabled />
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label" for="flValorSigilosoItem">Valor sigiloso</label>
                                                <div class="form-check mt-2">
                                                    <input type="checkbox"
                                                           class="form-check-input"
                                                           id="flValorSigilosoItem"
                                                           v-model="item.flValorSigiloso" />
                                                    <label class="form-check-label" for="flValorSigilosoItem">Valor sigiloso</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-actions">
                                    <button class="modern-btn modern-btn-primary" @click="salvarItemFinal">
                                        {{ modoEdicao ? 'Atualizar item' : 'Incluir item' }}
                                    </button>
                                    <button v-if="modoEdicao" class="modern-btn modern-btn-secondary" type="button" @click="cancelarEdicao">
                                        Cancelar edição
                                    </button>
                                </div>
                            </div>
                        </transition>
                        <div class="divider"></div>

                        <div class="table-section">
                            <div class="table-topbar">
                                <div class="section-header">
                                    <h4>Itens cadastrados</h4>
                                    <p>Gerencie os itens existentes. Utilize os botões de ação para editá-los ou removê-los.</p>
                                </div>

                                <div class="lote-total-box" v-if="isLoteUnico">
                                    <span class="lote-total-label">Total do lote</span>
                                    <strong class="lote-total-value">
                                        R$ {{ formatarNumero(totalLoteSelecionado()) }}
                                    </strong>
                                </div>

                                <div class="lote-selected-box" v-else>
                                    <span class="lote-total-label">Lote selecionado</span>
                                    <strong class="lote-selected-value">
                                        {{ loteSelecionado ? `Lote ${loteSelecionado}` : '-' }}
                                    </strong>

                                    <span class="lote-selected-sub-label" v-if="loteSelecionado">Total</span>
                                    <strong class="lote-selected-sub-value" v-if="loteSelecionado">
                                        R$ {{ formatarNumero(totalDoLote(loteSelecionado)) }}
                                    </strong>
                                </div>
                            </div>


                            <div class="table-wrapper modern-table">
                                <div v-if="isLoteUnico">
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Código</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Sequência</th>
                                                <th>Nome</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Unidade</th>
                                                <th v-if="exibirColunaPeriodicidade" class="text-center" style="width: 1%; white-space: nowrap;">Periodicidade</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Qtd.</th>
                                                <th class="text-center" style="width: 10%; white-space: nowrap;">Unitário (R$)</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Total (R$)</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in itensDetalhados" :key="item.idProcessoItem">
                                                <td class="text-center" style="width: 1%; white-space: nowrap;">{{ item.codigo }}</td>
                                                <td class="text-center" style="width: 1%; white-space: nowrap;">{{ item.ordenacao }}</td>
                                                <td>{{ item.nome }}</td>
                                                <td class="text-center" style="width: 1%; white-space: nowrap;">{{ item.unidadeMedida }}</td>
                                                <td v-if="exibirColunaPeriodicidade" class="text-center" style="width: 1%; white-space: nowrap;">{{ formatarPeriodicidadeItem(item) }}</td>
                                                <td class="text-center" style="width: 1%; white-space: nowrap;">
                                                    <input type="number"
                                                           step="0.01"
                                                           class="form-control form-control-sm"
                                                           :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                           :value="edicaoLinha[item.idProcessoItem]?.qtd"
                                                           @input="onEditQtdLinha(item.idProcessoItem, $event)"
                                                           style="min-width: 90px;" />

                                                </td>
                                                <td class="text-center" style="width: 10%; white-space: nowrap;">
                                                    <div class="input-group input-group-sm" style="min-width: 140px;">
                                                        <span class="input-group-text">R$</span>
                                                        <input type="text"
                                                               class="form-control"
                                                               :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                               :value="edicaoLinha[item.idProcessoItem]?.vlUnitFmt"
                                                               @input="onEditValorUnitLinha(item.idProcessoItem, $event)"
                                                               @blur="onBlurValorUnitLinha(item.idProcessoItem)" />

                                                    </div>
                                                </td>
                                                <td class="text-center" style="width: 1%; white-space: nowrap;">
                                                    {{ formatarNumero(totalLinha(item.idProcessoItem)) }}
                                                </td>
                                                <td class="text-center" style="width: 1%; white-space: nowrap;">
                                                    <div class="action-buttons" v-if="!modoVisualizacao">

                                                        <template v-if="!edicaoLinha[item.idProcessoItem]?.dirty">
                                                            <button class="action-btn action-btn-view"
                                                                    @click="editarItem(item.idProcessoItem)"
                                                                    :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                    title="Editar item">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                                    <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                    <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                                </svg>
                                                                Editar
                                                            </button>

                                                            <button class="action-btn action-btn-delete"
                                                                    @click="removerItem(item.idProcessoItem)"
                                                                    :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                    title="Excluir item">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                                    <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                    <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                </svg>
                                                            </button>
                                                        </template>

                                                        <template v-else>
                                                            <button class="action-btn action-btn-success"
                                                                    @click="salvarEdicaoLinha(item.idProcessoItem)"
                                                                    :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                    title="Salvar alterações">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-floppy" viewBox="0 0 16 16">
                                                                    <path d="M11 2H9v3h2z" />
                                                                    <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z" />
                                                                </svg>
                                                                Salvar
                                                            </button>

                                                            <button class="action-btn action-btn-secondary"
                                                                    @click="cancelarEdicaoLinha(item.idProcessoItem)"
                                                                    :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                    title="Cancelar alterações">
                                                                Cancelar
                                                            </button>
                                                        </template>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr v-if="itensDetalhados.length === 0">
                                                <td :colspan="colunasTabelaItens" class="empty-state">
                                                    <div class="empty-content">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" />
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4Z" />
                                                        </svg>
                                                        <h3 class="empty-title">Nenhum item registrado</h3>
                                                        <p class="empty-description">Inclua um item manualmente ou importe uma planilha para começar.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else>
                                    <div class="lote-header-container mb-3">
                                        <div class="lote-scroll-wrapper">
                                            <div class="lote-scroll">
                                                <button v-for="lote in lotesUnicos()"
                                                        :key="lote"
                                                        @click="loteSelecionado = lote"
                                                        class="btn btn-outline-primary btn-lote"
                                                        :class="{ 'btn-lote-ativo': lote === loteSelecionado }">
                                                    Lote {{ lote }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="lote-actions" v-if="!isLoteUnico">
                                            <div class="lote-actions-buttons">
                                                <button class="lot-btn lot-btn-add" @click="criarNovoLote">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4Z" />
                                                    </svg>
                                                    Novo lote
                                                </button>
                                                <button class="lot-btn lot-btn-remove" @click="removerLote" title="Excluir lote atual">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                    </svg>
                                                    Remover lote
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <table class="custom-table">
                                        <thead>
                                            <tr>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Código</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Sequência</th>
                                                <th>Nome</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Unidade</th>
                                                <th v-if="exibirColunaPeriodicidade" class="text-center" style="width: 1%; white-space: nowrap;">Periodicidade</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Qtd.</th>
                                                <th class="text-center" style="width: 10%; white-space: nowrap;">Unitário (R$)</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Total (R$)</th>
                                                <th class="text-center" style="width: 1%; white-space: nowrap;">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="itensDetalhados.filter(i => i.lote === loteSelecionado).length">
                                                <tr v-for="item in itensDetalhados.filter(i => i.lote === loteSelecionado)" :key="item.idProcessoItem">
                                                    <td class="text-center" style="width: 1%; white-space: nowrap;">{{ item.codigo }}</td>
                                                    <td class="text-center" style="width: 1%; white-space: nowrap;">{{ item.ordenacao }}</td>
                                                    <td>{{ item.nome }}</td>
                                                    <td class="text-center" style="width: 1%; white-space: nowrap;">{{ item.unidadeMedida }}</td>
                                                    <td v-if="exibirColunaPeriodicidade" class="text-center" style="width: 1%; white-space: nowrap;">{{ formatarPeriodicidadeItem(item) }}</td>
                                                    <td class="text-center" style="width: 1%; white-space: nowrap;">
                                                        <input type="number"
                                                               step="0.01"
                                                               class="form-control form-control-sm"
                                                               :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                               :value="edicaoLinha[item.idProcessoItem]?.qtd"
                                                               @input="onEditQtdLinha(item.idProcessoItem, $event)"
                                                               style="min-width: 90px;" />

                                                    </td>
                                                    <td class="text-center" style="width: 10%; white-space: nowrap;">
                                                        <div class="input-group input-group-sm" style="min-width: 140px;">
                                                            <span class="input-group-text">R$</span>
                                                            <input type="text"
                                                                   class="form-control"
                                                                   :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                   :value="edicaoLinha[item.idProcessoItem]?.vlUnitFmt"
                                                                   @input="onEditValorUnitLinha(item.idProcessoItem, $event)"
                                                                   @blur="onBlurValorUnitLinha(item.idProcessoItem)" />

                                                        </div>
                                                    </td>
                                                    <td class="text-center" style="width: 1%; white-space: nowrap;">
                                                        {{ formatarNumero(totalLinha(item.idProcessoItem)) }}
                                                    </td>
                                                    <td class="text-center" style="width: 1%; white-space: nowrap;">
                                                        <div class="action-buttons">

                                                            <template v-if="!edicaoLinha[item.idProcessoItem]?.dirty">
                                                                <button class="action-btn action-btn-view"
                                                                        @click="editarItem(item.idProcessoItem)"
                                                                        :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                        title="Editar item">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                                                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                        <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                                    </svg>
                                                                    Editar
                                                                </button>

                                                                <button class="action-btn action-btn-delete"
                                                                        @click="removerItem(item.idProcessoItem)"
                                                                        :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                        title="Excluir item">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                                    </svg>
                                                                </button>
                                                            </template>

                                                            <template v-else>
                                                                <button class="action-btn action-btn-success"
                                                                        @click="salvarEdicaoLinha(item.idProcessoItem)"
                                                                        :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                        title="Salvar alterações">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-floppy" viewBox="0 0 16 16">
                                                                        <path d="M11 2H9v3h2z" />
                                                                        <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z" />
                                                                    </svg>
                                                                    Salvar
                                                                </button>

                                                                <button class="action-btn action-btn-secondary"
                                                                        @click="cancelarEdicaoLinha(item.idProcessoItem)"
                                                                        :disabled="edicaoLinha[item.idProcessoItem]?.saving"
                                                                        title="Cancelar alterações">
                                                                    Cancelar
                                                                </button>
                                                            </template>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            <tr v-else>
                                                <td :colspan="colunasTabelaItens" class="empty-state">
                                                    <div class="empty-content">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14Zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16Z" />
                                                            <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4Z" />
                                                        </svg>
                                                        <h3 class="empty-title">Nenhum item registrado</h3>
                                                        <p class="empty-description">Inclua um item manualmente ou importe uma planilha para começar.</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade modern-modal" id="modalNovaUnidade" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered modal-modern modal-nova-unidade">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>
                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none">
                                <path d="M12 4V20M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Nova Unidade de Medida</h2>
                            <p>Cadastre uma unidade personalizada para utilizar nos itens do processo.</p>
                        </div>
                    </div>
                    <div class="modal-modern-body modal-body-unidade">
                        <div class="helper-box">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" />
                            </svg>
                            <span>Informe o nome no singular (por exemplo: “Metro”, “Quilo”, “Litro”).</span>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Nome</label>
                            <input type="text"
                                   v-model="novaUnidade.nome"
                                   class="form-control"
                                   :class="{ 'border-danger': camposInvalidosUnidade.nome }"
                                   placeholder="Ex: Quilograma" />
                        </div>
                        <div class="form-group">
                            <label class="form-label">Código</label>
                            <input type="text"
                                   v-model="novaUnidade.codigo"
                                   class="form-control"
                                   :class="{ 'border-danger': camposInvalidosUnidade.codigo }"
                                   placeholder="Ex: Kg" />
                        </div>
                        <div class="form-group mb-0">
                            <div class="form-check form-switch periodicidade-switch">
                                <input class="form-check-input"
                                       type="checkbox"
                                       id="swPeriodicidade"
                                       v-model="novaUnidade.flPeriodicidade">
                                <label class="form-check-label" for="swPeriodicidade">Possui periodicidade</label>
                            </div>
                            <small class="periodicidade-hint">Marque quando a unidade representa um intervalo de tempo (ex.: mês, ano).</small>
                        </div>
                        <button class="modern-btn modern-btn-primary w-100" @click="salvarNovaUnidade">Salvar unidade</button>
                    </div>
                </div>
            </div>
        </div>
        <ModalImportacaoItem ref="modalImportacaoItem"
                             :idProcesso="idProcesso"
                             :isLoteUnico="isLoteUnico"
                             @fechaModalImportacao="reabrirModalItem" />
    </div>
</template>


<script>
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import Swal from 'sweetalert2'
    import axios from 'axios'
    import moment from 'moment'
    import ModalImportacaoItem from '@/components/ModalImportacaoItem.vue'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    export default {
        components: { ModalImportacaoItem, 'v-select': vSelect },
        props: {
            showModal: Boolean,
            idProcesso: String,
            modoVisualizacao: Boolean,
        },
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
            unidadeExigePeriodicidade() {
                if (!this.unidadeSelecionada) return false;
                const um = this.unidadesMedida.find(u => Number(u.idUnidadeMedida) === Number(this.unidadeSelecionada));
                return !!um?.flPeriodicidade;
            },
            bloqueiaIdentificacaoItem() {
                return this.modoEdicao || this.modoOrigemItem === 'CATALOGO';
            },
            exibirColunaPeriodicidade() {
                return (this.itensDetalhados || []).some(i =>
                    Number(i.idPeriodicidade) > 0 || !!(i.periodicidade && String(i.periodicidade).trim())
                );
            },
            colunasTabelaItens() {
                return this.exibirColunaPeriodicidade ? 9 : 8;
            },
        },
        data() {
            return {
                unidadesMedida: [],
                periodicidades: [],
                unidadeSelecionada: '',
                periodicidadeSelecionada: '',
                lotes: [],
                processosItens: [],
                itensDetalhados: [],
                novaUnidade: {
                    nome: '',
                    codigo: '',
                    flPeriodicidade: false
                },
                modalNovaUnidade: null,
                camposInvalidosUnidade: {
                    nome: false,
                    codigo: false
                },
                item: {
                    nome: '',
                    codigo: '',
                    referencia: '',
                    tpItem: '',
                    quantidade: '',
                    valorUnitario: '',
                    valorUnitarioFormatado: '',
                    valorTotal: '',
                    flValorSigiloso: false,
                    idProcessoItem: null,
                },

                camposInvalidosItem: {
                    nome: false,
                    codigo: false,
                    referencia: false,
                    tpItem: false,
                    unidadeSelecionada: false,
                    periodicidadeSelecionada: false,
                    quantidade: false,
                    valorUnitario: false
                },
                itens: null,
                myModalAlternative: null,
                loteVerificado: false,
                isLoteUnico: false,
                loteSelecionado: null,
                idItem: 0,
                idProcessoItem: 0,
                modoEdicao: false,
                retornarParaModalItem: false,
                modoOrigemItem: 'NOVO',
                tipoBuscaCatalogo: 'NOME',
                itemCatalogoSelecionado: null,
                listaItensCatalogo: [],
                buscandoCatalogo: false,
                catalogoDebounce: null,
                edicaoLinha: {},
                mostrarCadastroItem: false,
            }
        },

        mounted() {
            this.myModalAlternative = new window.bootstrap.Modal('#ModalItem');
            this.modalNovaUnidade = new window.bootstrap.Modal('#modalNovaUnidade');

            const modalNovaEl = document.getElementById('modalNovaUnidade');
            modalNovaEl.addEventListener('hidden.bs.modal', () => {
                this.retornarParaModalItem = false;
                this.myModalAlternative.show();
            });

            const modalEl = document.getElementById('ModalItem');
            modalEl.addEventListener('hidden.bs.modal', () => {
                if (!this.retornarParaModalItem) {
                    this.loteVerificado = false;
                    this.limparItem();
                    this.$emit('close');
                }
            });

            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },

        watch: {
            showModal(newValue) {
                if (newValue) this.abrir();
            },

            modoOrigemItem(val) {
                if (this.modoEdicao) return;

                this.itemCatalogoSelecionado = null;
                this.listaItensCatalogo = [];

                this.item.idItem = null;

                if (val === 'NOVO') {
                    this.item.nome = '';
                    this.item.codigo = '';
                    this.item.referencia = '';
                    this.item.tpItem = '';
                } else {
                    this.item.nome = '';
                    this.item.codigo = '';
                    this.item.referencia = '';
                    this.item.tpItem = '';
                }

                this.resetarValidacoesItem();
            },

            unidadeSelecionada() {
                if (!this.unidadeExigePeriodicidade) {
                    this.periodicidadeSelecionada = '';
                }
            }

        },

        methods: {

            InitSignalR() {
                try {
                    const hub = this.hubConection;
                    if (!hub) return;

                    hub.on("RecebeNotificacaoImportacaoItem", (idProcesso, status, dtAtualizacao) => {
                        if (this.idProcesso == idProcesso) {
                            this.getItensDetalhados();
                            this.getProcessosItensLotes();

                        } else {
                            avisoErro(`Importação de itens falhou - ${moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm')}`);
                        }
                    });
                } catch (ex) {
                    console.error('Erro no InitSignalR:', ex);
                }
            },

            abrir() {
                this.myModalAlternative.show();
                this.resetarValidacoesItem();
                this.VerificaLoteUnico();
                this.getUnidadesMedida();
                this.getPeriodicidades();
                this.getProcessosItensLotes();
                this.getItensDetalhados();
            },

            formatarValorUnitario(event) {
                const digits = (event.target.value || '').replace(/\D/g, '');
                const num = (parseInt(digits || '0', 10) / 100);

                this.item.valorUnitario = isNaN(num) ? 0 : num;
                this.item.valorUnitarioFormatado = (this.item.valorUnitario).toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                this.calcularTotal();
            },

            getPeriodicidades() {
                return axios.get(`${urlApi}/CadastroItem/GetPeriodicidades`)
                    .then(res => {
                        if (res.data) {
                            this.periodicidades = res.data.data || [];
                        } else {
                            avisoErro("Não foi possível carregar as periodicidades.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar periodicidades.");
                    });
            },

            getUnidadesMedida() {
                return axios.get(`${urlApi}/CadastroItem/GetUnidadesMedida`)
                    .then(res => {
                        if (res.data) {
                            this.unidadesMedida = res.data.data;
                        } else {
                            avisoErro("Não foi possível carregar as unidades de medida.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar unidades de medida.");
                    });
            },

            VerificaLoteUnico() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/VerificaLoteUnico`, { params: { idProcesso: this.idProcesso } })
                    .then(res => {
                        if (res.data) {
                            var result = res.data.data;
                            $this.isLoteUnico = result.isLoteUnico;
                        } else {
                            avisoErro("Não foi possível verificar se o lote é único.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar configuração.");
                    });
            },

            getProcessosItens() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetProcessoItem`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        var result = res.data.data;
                        $this.processosItens = result.rows;
                        if (!res.data) {
                            avisoErro("Não foi possível carregar os itens do processo.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar itens do processo.");
                    });
            },

            getProcessosItensLotes() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetProcessoItemLote`, {
                    params: { idProcesso: this.idProcesso }
                }).then(res => {
                    const lotes = res.data.data.rows || [];
                    if (lotes.length > 0) {
                        $this.lotes = lotes;
                        if (!this.loteSelecionado) {
                            this.loteSelecionado = this.lotes[0].processoItemLote.nrLote;
                        }
                    } else if (!this.loteVerificado) {
                        $this.loteVerificado = true;
                        $this.criarNovoLote().then(() => $this.getProcessosItensLotes());
                    }
                }).catch(() => {
                    avisoErro("Erro ao buscar lotes.");
                });
            },

            editarItem(idProcessoItem) {
                axios.get(`${urlApi}/CadastroItem/GetItemCompleto`, {
                    params: { idProcessoItem }
                })
                    .then(res => {
                        if (res.data?.success && res.data.data?.rows?.length > 0) {
                            this.resetarValidacoesItem();
                            const dados = res.data.data.rows[0];
                            this.item.idItem = dados.idItem;
                            this.item.idProcessoItem = dados.idProcessoItem;
                            this.item.nome = dados.nmItem;
                            this.item.codigo = dados.cdItem;
                            this.item.referencia = dados.cdReferencia;
                            this.item.tpItem = dados.tpItem;
                            this.item.quantidade = dados.qtdItem;
                            this.item.valorUnitario = dados.vlUnitarioItem;
                            this.item.valorUnitarioFormatado = dados.vlUnitarioItem.toFixed(2).replace('.', ',');
                            this.item.valorTotal = (dados.qtdItem * dados.vlUnitarioItem).toFixed(2);
                            this.item.flValorSigiloso = !!dados.flValorSigiloso;
                            this.unidadeSelecionada = dados.idUnidadeMedida;
                            this.periodicidadeSelecionada = dados.idPeriodicidade || '';
                            this.itemCatalogoSelecionado = null;
                            this.modoEdicao = true;
                            this.mostrarCadastroItem = true;
                            this.$nextTick(() => {
                                this.myModalAlternative.show();
                                const form = this.$el.querySelector('.form-section');
                                form && form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            });
                        } else {
                            avisoErro("Não foi possível carregar os dados do item.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar dados do item.");
                    });
            },

            cancelarEdicao() {
                this.limparItem();
                this.modoEdicao = false;
                this.mostrarCadastroItem = false;
                this.modoOrigemItem = 'NOVO';
                this.resetarValidacoesItem();
            },

            getItensDetalhados() {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoItem/GetItensModal`, {
                    params: { idProcesso: this.idProcesso }
                })
                    .then(res => {
                        if (res.data && res.data.data && res.data.data.rows) {
                            $this.itensDetalhados = res.data.data.rows;
                            $this.itensDetalhados.forEach(row => {
                                const id = row.idProcessoItem;
                                if (!id) return;

                                const qtd = parseFloat(row.quantidade || 0);
                                const vlUnit = parseFloat(row.valorUnitario || 0);

                                const atual = $this.edicaoLinha[id];

                                if (!atual) {
                                    $this.$set($this.edicaoLinha, id, {
                                        qtd,
                                        vlUnit,
                                        vlUnitFmt: vlUnit.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                                        originalQtd: qtd,
                                        originalVlUnit: vlUnit,
                                        dirty: false,
                                        saving: false,
                                    });
                                    return;
                                }

                                if (atual.dirty || atual.saving) return;
                                $this.$set($this.edicaoLinha, id, {
                                    ...atual,
                                    qtd,
                                    vlUnit,
                                    vlUnitFmt: vlUnit.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                                    originalQtd: qtd,
                                    originalVlUnit: vlUnit,
                                    dirty: false,
                                });
                            });

                        } else {
                            avisoErro("Não foi possível carregar os itens detalhados do processo.");
                        }
                    })
                    .catch(() => {
                        avisoErro("Erro ao buscar os itens detalhados do processo.");
                    });
            },

            limparItem() {
                this.item = {
                    idItem: null,
                    idProcessoItem: null,
                    nome: '',
                    codigo: '',
                    referencia: '',
                    tpItem: '',
                    quantidade: '',
                    valorUnitario: '',
                    valorUnitarioFormatado: '',
                    valorTotal: '',
                    flValorSigiloso: false,
                };
                this.unidadeSelecionada = '';
                this.periodicidadeSelecionada = '';
                this.modoEdicao = false;
            },

            criarNovoLote() {
                return axios.post(`${urlApi}/ProcessoItem/PostLote`, {
                    idProcesso: this.idProcesso
                }).then(res => {
                    if (res.data?.success) {
                        avisoToast("Lote criado com sucesso.");
                        this.getProcessosItensLotes().then(() => {
                            const lotesNumericos = this.lotes.map(l => l.processoItemLote.nrLote);
                            const maiorLote = Math.max(...lotesNumericos);

                            this.loteSelecionado = maiorLote;
                            this.getItensDetalhados();
                        });

                    } else {
                        avisoErro(res.data?.msg || "Erro ao criar novo lote.");
                    }
                }).catch(() => {
                    avisoErro("Erro ao criar novo lote.");
                });
            },

            abrirModalNovaUnidade() {
                this.retornarParaModalItem = true;
                this.myModalAlternative.hide();
                this.modalNovaUnidade.show();
            },

            fecharModalNovaUnidade() {
                this.modalNovaUnidade.hide();
                this.myModalAlternative.show();
            },

            reabrirModalItem() {
                this.myModalAlternative.show();
            },

            salvarNovaUnidade() {
                this.camposInvalidosUnidade.nome = !this.novaUnidade.nome?.trim();
                this.camposInvalidosUnidade.codigo = !this.novaUnidade.codigo?.trim();

                if (this.camposInvalidosUnidade.nome || this.camposInvalidosUnidade.codigo) {
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return;
                }

                const payload = {
                    nmUnidadeMedida: this.novaUnidade.nome,
                    cdUnidadeMedida: this.novaUnidade.codigo,
                    flPeriodicidade: !!this.novaUnidade.flPeriodicidade
                };

                axios.post(`${urlApi}/CadastroItem/NovaUnidade`, payload)
                    .then(res => {
                        if (res.data?.success) {
                            avisoToast('Unidade criada com sucesso!');
                            this.fecharModalNovaUnidade();
                            this.novaUnidade.nome = '';
                            this.novaUnidade.codigo = '';
                            this.novaUnidade.flPeriodicidade = false;
                            this.getUnidadesMedida();
                            this.camposInvalidosUnidade.nome = false;
                            this.camposInvalidosUnidade.codigo = false;
                        } else {
                            avisoErro(res.data?.msg || 'Erro ao criar unidade.');
                        }
                    })
                    .catch(() => {
                        avisoErro('Erro ao criar unidade.');
                    });
            },

            formatarPeriodicidade(p) {
                return `${p.nmPeriodicidade} (${p.cdPeriodicidade})`;
            },

            formatarPeriodicidadeItem(item) {
                if (item?.periodicidade && String(item.periodicidade).trim()) {
                    return item.periodicidade;
                }
                if (Number(item?.idPeriodicidade) > 0) {
                    const p = this.periodicidades.find(x => Number(x.idPeriodicidade) === Number(item.idPeriodicidade));
                    if (p) return this.formatarPeriodicidade(p);
                }
                return '-';
            },

            formatarUnidade(um) {
                return `${um.nmUnidadeMedida} (${um.cdUnidadeMedida})`;
            },

            lotesUnicos() {
                return [...new Set(this.lotes.map(l => l.processoItemLote.nrLote))].sort((a, b) => a - b);
            },

            calcularTotal() {
                const q = parseFloat(this.item.quantidade || 0);
                const v = parseFloat(this.item.valorUnitario || 0);
                const total = q * v;

                this.item.valorTotal = isNaN(total) ? '' : total.toFixed(2);
            },

            resetarValidacoesItem() {
                this.camposInvalidosItem = {
                    nome: false,
                    codigo: false,
                    referencia: false,
                    tpItem: false,
                    unidadeSelecionada: false,
                    periodicidadeSelecionada: false,
                    quantidade: false,
                    valorUnitario: false
                };
            },

            onCdItemInput(event) {
                const digits = String(event.target.value || '').replace(/\D/g, '').slice(0, 100);
                this.item.codigo = digits;
                event.target.value = digits;
                this.camposInvalidosItem.codigo = false;
            },

            validarItem() {
                const { item, unidadeSelecionada } = this;

                this.camposInvalidosItem.unidadeSelecionada = !unidadeSelecionada;
                this.camposInvalidosItem.periodicidadeSelecionada = this.unidadeExigePeriodicidade && !this.periodicidadeSelecionada;
                this.camposInvalidosItem.quantidade = !item.quantidade;
                const valor = item.valorUnitario;
                this.camposInvalidosItem.valorUnitario = valor === '' || valor === null || valor === undefined || Number.isNaN(Number(valor)) || Number(valor) < 0;

                if (this.modoEdicao) {
                    this.camposInvalidosItem.nome = false;
                    this.camposInvalidosItem.tpItem = false;
                    this.camposInvalidosItem.codigo = false;
                    return !Object.values(this.camposInvalidosItem).some(campo => campo);
                }

                this.camposInvalidosItem.nome = !item.nome?.trim();
                this.camposInvalidosItem.tpItem = !item.tpItem;

                const cdItem = String(item.codigo || '').replace(/\D/g, '').slice(0, 100);
                if (this.modoOrigemItem === 'NOVO') {
                    this.item.codigo = cdItem;
                    this.camposInvalidosItem.codigo = !!cdItem && !/^\d{1,100}$/.test(cdItem);
                } else {
                    this.camposInvalidosItem.codigo = false;
                }

                return !Object.values(this.camposInvalidosItem).some(campo => campo);
            },

            async salvarItemFinal() {
                if (!this.validarItem()) {
                    if (this.camposInvalidosItem.codigo) {
                        avisoErro("O código deve conter somente números, com até 100 caracteres.");
                        return;
                    }
                    avisoErro("Preencha todos os campos obrigatórios.");
                    return;
                }

                let idItemFinal = this.item.idItem;
                const codigoNovo = String(this.item.codigo || '').trim();
                const idEditando = this.item.idProcessoItem || 0;

                if (!this.modoEdicao && codigoNovo) {
                    const existeCodigoNoMesmoLote = this.itensDetalhados.some(i => {
                        const mesmoLote = i.lote === this.loteSelecionado;
                        const mesmoCodigo = i.codigo?.trim().toLowerCase() === codigoNovo.toLowerCase();
                        const outroItem = i.idProcessoItem !== idEditando;
                        return mesmoLote && mesmoCodigo && outroItem;
                    });

                    if (existeCodigoNoMesmoLote) {
                        avisoErro("Já existe um item com esse código neste lote.");
                        return;
                    }
                }

                try {
                    if (!this.modoEdicao && !idItemFinal) {
                        const payloadItem = {
                            DadosItem: {
                                cdItem: codigoNovo || null,
                                cdReferencia: this.item.referencia,
                                nmItem: this.item.nome,
                                tpItem: this.item.tpItem
                            }
                        };

                        const resItem = await axios.post(`${urlApi}/CadastroItem/PostItem`, payloadItem);

                        if (!resItem.data?.success) {
                            const msg = (resItem.data && (resItem.data.errors?.[0] || resItem.data.msg))
                                ? (resItem.data.errors?.[0] || resItem.data.msg)
                                : "Erro ao salvar o item.";
                            avisoErro(msg);
                            return;
                        }

                        idItemFinal = resItem.data.data;
                    }
                    const lote = this.lotes.find(l => l.processoItemLote.nrLote === this.loteSelecionado);
                    if (!lote) {
                        avisoErro("Lote não encontrado.");
                        return;
                    }

                    const payloadProcessoItem = {
                        dadosProcessoItem: {
                            idProcessoItem: this.item.idProcessoItem || 0,
                            idProcesso: this.idProcesso,
                            idItem: idItemFinal,
                            idProcessoItemLote: lote.processoItemLote.idProcessoItemLote,
                            idUnidadeMedida: this.unidadeSelecionada,
                            idPeriodicidade: this.unidadeExigePeriodicidade ? this.periodicidadeSelecionada : null,
                            qtdItem: this.item.quantidade,
                            vlUnitarioItem: this.item.valorUnitario,
                            vlTotalItem: parseFloat(this.item.valorUnitario) * parseFloat(this.item.quantidade),
                            flValorSigiloso: !!this.item.flValorSigiloso,
                            tpItem: this.item.tpItem
                        }
                    };

                    const resProc = await axios.post(`${urlApi}/ProcessoItem/PostProcessoItem`, payloadProcessoItem);

                    if (!resProc.data?.success) {
                        avisoErro("Erro ao salvar o item no processo.");
                        return;
                    }

                    avisoToast(this.modoEdicao ? "Item atualizado com sucesso!" : "Item cadastrado com sucesso!");
                    this.modoEdicao = false;
                    this.mostrarCadastroItem = false;
                    this.limparItem();
                    this.getItensDetalhados();
                    this.getProcessosItens();

                } catch (err) {
                    console.error(err);
                    const msg = err?.response?.data?.errors?.[0]
                        || err?.response?.data?.msg
                        || "Erro ao salvar o item.";
                    avisoErro(msg);
                }
            },

            async removerItem(idProcessoItem) {
                if (!idProcessoItem) {
                    avisoErro("Item inválido.");
                    return;
                }

                Swal.fire({
                    title: 'Excluir item?',
                    text: 'Esta ação removerá o item do processo.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#2563EB',
                    confirmButtonText: 'Sim, excluir',
                    cancelButtonText: 'Cancelar'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const res = await axios.post(`${urlApi}/ProcessoItem/DeleteProcessoItem`, {
                                idProcessoItem: idProcessoItem
                            });

                            if (res.data?.success !== false) {
                                avisoToast("Item excluído com sucesso.");
                                this.getItensDetalhados();
                            } else {
                                avisoErro(res.data?.msg || "Erro ao excluir item.");
                            }
                        } catch (error) {
                            console.error(error);
                            avisoErro("Erro ao excluir item.");
                        }
                    }
                });
            },

            async removerLote() {
                const loteAtual = this.lotes.find(l => l.processoItemLote.nrLote === this.loteSelecionado);

                if (!loteAtual || !loteAtual.processoItemLote.idProcessoItemLote) {
                    avisoErro("Lote inválido.");
                    return;
                }

                Swal.fire({
                    title: `Excluir lote ${this.loteSelecionado}?`,
                    text: `Todos os itens vinculados ao lote ${this.loteSelecionado} serão removidos.`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#2563EB',
                    confirmButtonText: 'Sim, excluir',
                    cancelButtonText: 'Cancelar'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        try {
                            const res = await axios.post(`${urlApi}/ProcessoItem/DeleteProcessoLote`, {
                                idProcessoItemLote: loteAtual.processoItemLote.idProcessoItemLote
                            });

                            if (res.data?.success !== false) {
                                avisoToast("Lote excluído com sucesso.");
                                await this.getItensDetalhados();
                                await this.getProcessosItensLotes();

                                const lotesNumericos = this.lotes.map(l => l.processoItemLote.nrLote);
                                this.loteSelecionado = lotesNumericos.length > 0 ? Math.min(...lotesNumericos) : null;
                            } else {
                                avisoErro(res.data?.msg || "Erro ao excluir lote.");
                            }
                        } catch (error) {
                            console.error(error);
                            avisoErro("Erro ao excluir lote.");
                        }
                    }
                });
            },

            formatarNumero(valor, casasDecimais = 2) {
                if (typeof valor !== 'number') {
                    valor = parseFloat(valor);
                }
                if (isNaN(valor)) return '';

                return valor.toLocaleString('pt-BR', {
                    minimumFractionDigits: casasDecimais,
                    maximumFractionDigits: casasDecimais,
                });
            },

            importacaoItens() {
                this.myModalAlternative.hide();

                this.$nextTick(() => {
                    if (this.$refs.modalImportacaoItem?.abrirModal) {
                        this.$refs.modalImportacaoItem.abrirModal(() => {
                            this.myModalAlternative.show();
                        });
                    }
                });
            },
            onSearchCatalogo(search) {
                const termo = (search || '').trim();

                if (termo.length < 3) {
                    this.listaItensCatalogo = [];
                    return;
                }

                clearTimeout(this.catalogoDebounce);
                this.catalogoDebounce = setTimeout(async () => {
                    this.buscandoCatalogo = true;
                    try {
                        const params = { take: 20, index: 0, dsTermo: termo };
                        const res = await axios.get(`${urlApi}/CadastroItem/Get`, { params });

                        if (res.data?.success) {
                            const rows = res.data.data?.rows || [];
                            this.listaItensCatalogo = rows
                                .map(r => r.item || r.cadastroItem || r)
                                .filter(o => o && (o.idItem || o.cdItem || o.nmItem));
                        } else {
                            this.listaItensCatalogo = [];
                        }
                    } catch (e) {
                        console.error(e);
                        this.listaItensCatalogo = [];
                    } finally {
                        this.buscandoCatalogo = false;
                    }
                }, 300);
            },

            onEditLinha(id) {
                const e = this.edicaoLinha[id];
                if (!e) return;

                const qtd = parseFloat(e.qtd || 0);
                const vl = parseFloat(e.vlUnit || 0);

                const mudouQtd = Math.abs(qtd - (e.originalQtd || 0)) > 0.000001;
                const mudouVl = Math.abs(vl - (e.originalVlUnit || 0)) > 0.000001;

                e.dirty = mudouQtd || mudouVl;
            },

            onEditValorUnitLinha(id, event) {
                const e = this.edicaoLinha[id];
                if (!e) return;

                const digits = (event.target.value || '').replace(/\D/g, '');
                const num = (parseInt(digits || '0', 10) / 100);

                e.vlUnit = isNaN(num) ? 0 : num;
                e.vlUnitFmt = e.vlUnit.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                });

                this.onEditLinha(id);
            },

            onBlurValorUnitLinha(id) {
                const e = this.edicaoLinha[id];
                if (!e) return;

                if (!e.vlUnitFmt) {
                    e.vlUnit = 0;
                    e.vlUnitFmt = '0,00';
                }
            },

            onEditQtdLinha(id, event) {
                const e = this.edicaoLinha[id];
                if (!e) return;

                const v = parseFloat(event.target.value || 0);
                e.qtd = isNaN(v) ? 0 : v;

                this.onEditLinha(id);
            },

            totalLinha(id) {
                const e = this.edicaoLinha[id];
                if (!e) return 0;
                const total = (parseFloat(e.qtd || 0) * parseFloat(e.vlUnit || 0));
                return isNaN(total) ? 0 : total;
            },

            cancelarEdicaoLinha(id) {
                const e = this.edicaoLinha[id];
                if (!e) return;

                const novo = {
                    ...e,
                    qtd: e.originalQtd,
                    vlUnit: e.originalVlUnit,
                    vlUnitFmt: (e.originalVlUnit ?? 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),

                    dirty: false,
                };

                this.$set(this.edicaoLinha, id, novo);
            },

            async salvarEdicaoLinha(idProcessoItem) {
                const e = this.edicaoLinha[idProcessoItem];
                if (!e) return;
                if (!e.qtd || e.qtd <= 0) {
                    avisoErro("Quantidade inválida.");
                    return;
                }
                if (e.vlUnit === null || e.vlUnit === undefined || e.vlUnit === '' || Number.isNaN(Number(e.vlUnit)) || Number(e.vlUnit) < 0) {
                    avisoErro("Valor unitário inválido.");
                    return;
                }

                e.saving = true;

                try {
                    const res = await axios.get(`${urlApi}/CadastroItem/GetItemCompleto`, {
                        params: { idProcessoItem }
                    });

                    if (!res.data?.success || !res.data.data?.rows?.length) {
                        avisoErro("Não foi possível carregar dados do item para salvar.");
                        return;
                    }

                    const dados = res.data.data.rows[0];

                    const payloadProcessoItem = {
                        dadosProcessoItem: {
                            idProcessoItem: dados.idProcessoItem,
                            idProcesso: this.idProcesso,
                            idItem: dados.idItem,
                            idProcessoItemLote: dados.idProcessoItemLote,
                            idUnidadeMedida: dados.idUnidadeMedida,
                            idPeriodicidade: dados.idPeriodicidade || null,
                            qtdItem: e.qtd,
                            vlUnitarioItem: e.vlUnit,
                            vlTotalItem: parseFloat(e.qtd) * parseFloat(e.vlUnit),
                            flValorSigiloso: !!dados.flValorSigiloso,
                            tpItem: dados.tpItem
                        }
                    };

                    const save = await axios.post(`${urlApi}/ProcessoItem/PostProcessoItem`, payloadProcessoItem);

                    if (!save.data?.success) {
                        avisoErro(save.data?.msg || "Erro ao salvar alterações.");
                        return;
                    }

                    e.originalQtd = parseFloat(e.qtd);
                    e.originalVlUnit = parseFloat(e.vlUnit);
                    e.dirty = false;

                    const row = this.itensDetalhados.find(x => x.idProcessoItem === idProcessoItem);
                    if (row) {
                        row.quantidade = e.qtd;
                        row.valorUnitario = e.vlUnit;
                        row.valorTotal = parseFloat(e.qtd) * parseFloat(e.vlUnit);
                    }

                    avisoToast("Alterações salvas!");
                    await this.getItensDetalhados();

                } catch (err) {
                    console.error(err);
                    avisoErro("Erro ao salvar alterações.");
                } finally {
                    e.saving = false;
                }
            },

            async exportarExcel() {
                try {
                    const url = `${urlApi}/ProcessoItem/ExportItensExcel`;

                    const res = await axios.get(url, {
                        params: { idProcesso: this.idProcesso },
                        responseType: 'blob'
                    });

                    let fileName = 'itens_processo.xlsx';
                    const cd = res.headers?.['content-disposition'];
                    if (cd) {
                        const match = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i);
                        if (match && match[1]) fileName = decodeURIComponent(match[1]);
                    }

                    const blob = new Blob([res.data], {
                        type: res.headers?.['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });

                    const link = document.createElement('a');
                    const objectUrl = window.URL.createObjectURL(blob);
                    link.href = objectUrl;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(objectUrl);

                    avisoToast('Excel exportado com sucesso!');
                } catch (err) {
                    console.error(err);
                    avisoErro('Erro ao exportar Excel.');
                }
            },


            totalDoLote(nrLote) {
                const rows = (this.itensDetalhados || []).filter(r => r.lote === nrLote);

                return rows.reduce((acc, r) => {
                    const id = r.idProcessoItem;
                    const e = this.edicaoLinha?.[id];

                    const qtd = e ? parseFloat(e.qtd || 0) : parseFloat(r.quantidade || 0);
                    const vl = e ? parseFloat(e.vlUnit || 0) : parseFloat(r.valorUnitario || 0);

                    const total = qtd * vl;
                    return acc + (isNaN(total) ? 0 : total);
                }, 0);
            },

            totalLoteSelecionado() {
                if (this.isLoteUnico) {
                    return this.itensDetalhados.reduce((acc, r) => {
                        const id = r.idProcessoItem;
                        const e = this.edicaoLinha?.[id];
                        const qtd = e ? parseFloat(e.qtd || 0) : parseFloat(r.quantidade || 0);
                        const vl = e ? parseFloat(e.vlUnit || 0) : parseFloat(r.valorUnitario || 0);
                        const t = qtd * vl;
                        return acc + (isNaN(t) ? 0 : t);
                    }, 0);
                }

                if (!this.loteSelecionado) return 0;
                return this.totalDoLote(this.loteSelecionado);
            },

            abrirCadastroItem() {
                this.modoEdicao = false;
                this.limparItem();
                this.resetarValidacoesItem();
                this.modoOrigemItem = 'NOVO';
                this.mostrarCadastroItem = true;

                this.$nextTick(() => {
                    const el = this.$el.querySelector('input[placeholder*="Parafuso"], input.form-control');
                    el && el.focus();

                    const form = this.$el.querySelector('.form-section');
                    form && form.scrollIntoView({ behavior: 'smooth', block: 'start' });
                });
            },

            fecharCadastroItem() {
                this.mostrarCadastroItem = false;
                this.cancelarEdicao();
            },

            getLabelCatalogo(opt) {
                const o = opt || {};
                return `${o.cdReferencia || o.cdItem || ''} - ${o.nmItem || ''}`.trim();
            },

            onSelectCatalogoItem(opt) {
                if (!opt) {
                    this.item.idItem = null;
                    this.item.nome = '';
                    this.item.codigo = '';
                    this.item.referencia = '';
                    this.item.tpItem = '';
                    return;
                }

                this.item.idItem = opt.idItem;
                this.item.nome = opt.nmItem;
                this.item.codigo = opt.cdItem;
                this.item.referencia = opt.cdReferencia;
                this.item.tpItem = opt.tpItem;

                this.resetarValidacoesItem();
                this.calcularTotal();
            },

            normalizarReferencia(ref) {
                let r = (ref || '').trim();
                if (!r) return '';
                //if (!r.startsWith('#')) r = `#${r}`;
                return r;
            },

        }
    }
</script>
<style scoped>
    .modal-grande {
        width: 100% !important;
        max-width: calc(100vw - 40px) !important;
        margin: auto;
        margin-top: 20px;
        padding: 0 12px;
    }

    .modal-nova-unidade {
        width: 100% !important;
        max-width: 690px !important;
        margin: auto;
        padding: 0 12px;
    }

    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .btn-close-modern {
        border-radius: 50% !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        background: #ffffff !important;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .btn-close-modern:hover {
            transform: scale(1.08);
            box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        }

    .btn-md {
        z-index: 1001;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 18px;
        padding: 32px 32px 24px;
        position: relative;
    }

        .modal-modern-header::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 32px;
            right: 32px;
            height: 1px;
            background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
        }

    .header-icon {
        width: 60px;
        height: 60px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.16) 0%, rgba(59, 130, 246, 0.16) 100%);
        color: #0f766e;
    }

    .modal-nova-unidade .modal-modern-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 18px;
        padding: 28px 28px 20px;
        position: relative;
    }

        .modal-nova-unidade .modal-modern-header::after {
            left: 28px;
            right: 28px;
        }

    .modal-nova-unidade .header-icon {
        width: 56px;
        height: 56px;
    }

    .header-text {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

        .header-text h2 {
            margin: 0;
            font-size: 24px;
            font-weight: 700;
            color: #0f172a;
        }

        .header-text p {
            margin: 0;
            color: #475569;
            font-size: 14px;
            max-width: 420px;
            line-height: 1.4;
        }

    .header-actions {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-shrink: 0;
    }

    .modal-nova-unidade .header-actions {
        display: none;
    }

    .modal-modern-body {
        padding: 28px 32px 36px;
        display: flex;
        flex-direction: column;
        gap: 32px;
    }

    .form-section,
    .table-section {
        background: #ffffff;
        border-radius: 18px;
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 22px;
    }

    .modal-body-unidade {
        padding: 24px 28px 32px;
        gap: 20px;
    }

    .periodicidade-switch {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 12px 14px;
        border-radius: 12px;
        background: #f8fafc;
        border: 1px solid rgba(148, 163, 184, 0.25);
    }

        .periodicidade-switch .form-check-input {
            width: 2.5em;
            height: 1.25em;
            margin-top: 0;
            cursor: pointer;
        }

        .periodicidade-switch .form-check-label {
            font-weight: 600;
            color: #334155;
            cursor: pointer;
        }

    .periodicidade-hint {
        display: block;
        margin-top: 8px;
        font-size: 12px;
        color: #64748b;
        line-height: 1.4;
    }

    .helper-box {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 12px 14px;
        border-radius: 12px;
        background: rgba(59, 130, 246, 0.1);
        border: 1px solid rgba(59, 130, 246, 0.2);
        color: #1e40af;
        font-size: 13px;
        line-height: 1.4;
    }

        .helper-box svg {
            flex-shrink: 0;
        }

    .table-topbar {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 24px;
        flex-wrap: nowrap;
        width: 100%;
    }

        .table-topbar .section-header {
            flex: 1 1 auto;
            min-width: 0;
        }

        /* box do lado direito sempre “empurrado” pro canto */
        .table-topbar .lote-total-box,
        .table-topbar .lote-selected-box {
            margin-left: auto;
            flex: 0 0 auto;
            align-self: flex-start;
        }

    /* box multi-lote no mesmo estilo do total */
    .lote-selected-box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        padding: 12px 20px;
        border-radius: 12px;
        background: linear-gradient(135deg, rgba(239, 246, 255, 0.95) 0%, rgba(219, 234, 254, 0.95) 100%);
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
        min-width: 220px;
    }

    .lote-selected-value {
        font-size: 18px;
        font-weight: 800;
        color: #0f172a;
        line-height: 1.1;
    }

    .lote-selected-sub-label {
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.3px;
        color: #64748b;
        margin-top: 6px;
    }

    .lote-selected-sub-value {
        font-size: 20px;
        font-weight: 800;
        color: #0f172a;
        line-height: 1.1;
    }

    /* responsivo: empilha no mobile */
    @media (max-width:768px) {
        .table-topbar {
            flex-direction: column;
            align-items: stretch;
        }

            .table-topbar .lote-total-box,
            .table-topbar .lote-selected-box {
                margin-left: 0;
                align-items: flex-start;
                width: 100%;
            }
    }

    .section-header {
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

        .section-header.section-header-row {
            flex-direction: row;
            align-items: flex-start;
            justify-content: space-between;
            gap: 24px;
            flex-wrap: nowrap;
            width: 100%;
        }

            .section-header.section-header-row > div:first-child {
                flex: 1 1 auto;
                min-width: 0;
            }

            .section-header.section-header-row .lote-total-box {
                margin-left: auto;
                flex: 0 0 auto;
                align-self: flex-start;
                min-width: 180px;
            }

        .section-header h4 {
            margin: 0;
            font-size: 18px;
            font-weight: 700;
            color: #0f172a;
        }

        .section-header p {
            margin: 0;
            color: #64748b;
            font-size: 14px;
        }

    .lote-total-box {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 4px;
        padding: 12px 20px;
        border-radius: 12px;
        background: linear-gradient(135deg, rgba(239, 246, 255, 0.95) 0%, rgba(219, 234, 254, 0.95) 100%);
        border: 1px solid rgba(148, 163, 184, 0.2);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.1);
        min-width: 180px;
        flex: 0 0 auto;
        align-self: flex-start;
    }

    .lote-total-label {
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.3px;
        color: #2563eb;
    }

    .lote-total-value {
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.2;
    }

    .form-columns {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
        gap: 28px;
    }

    .form-column {
        display: flex;
        flex-direction: column;
        gap: 18px;
    }

    .form-row {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
        gap: 16px;
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .form-label {
        font-weight: 600;
        color: #0f172a;
        font-size: 13px;
        text-transform: uppercase;
        letter-spacing: 0.4px;
    }

    .modern-modal select.form-control {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%23838B99' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 14px 9px;
        padding-right: 46px;
        cursor: pointer;
    }

    .form-control {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        padding: 12px 14px;
        font-size: 14px;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
        background: #ffffff;
        color: #1f2937;
    }

        .form-control:focus {
            border-color: rgba(37, 99, 235, 0.6);
            box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
        }

        .form-control:disabled,
        .form-control[disabled] {
            background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
            border-color: rgba(148, 163, 184, 0.4);
            color: #64748b;
            cursor: not-allowed;
            opacity: 0.75;
            position: relative;
            user-select: none;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
        }

            .form-control:disabled::before,
            .form-control[disabled]::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background: repeating-linear-gradient( 45deg, transparent, transparent 8px, rgba(148, 163, 184, 0.08) 8px, rgba(148, 163, 184, 0.08) 16px );
                border-radius: 12px;
                pointer-events: none;
                opacity: 0.3;
            }

            .form-control:disabled:focus,
            .form-control[disabled]:focus {
                border-color: rgba(148, 163, 184, 0.4);
                box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
            }

    select.form-control:disabled,
    select.form-control[disabled] {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' opacity='0.5'/%3E%3C/svg%3E");
    }

    .input-with-action {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .input-with-action .unidade-select {
        flex: 1;
        min-width: 0;
    }

    :deep(.unidade-select.select-invalid .vs__dropdown-toggle) {
        border-color: #dc3545 !important;
        box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.15);
    }

    .modern-icon-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 42px;
        height: 42px;
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.35);
        background: #ffffff;
        color: #2563eb;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

        .modern-icon-btn:hover {
            transform: translateY(-1px);
            box-shadow: 0 10px 22px rgba(37, 99, 235, 0.18);
        }

    .modern-input-group .input-group-text {
        border-radius: 12px 0 0 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        border-right: none;
        background: rgba(37, 99, 235, 0.1);
        font-weight: 600;
        color: #1f2937;
    }

    .modern-input-group .form-control {
        border-radius: 0 12px 12px 0;
        border-left: none;
    }

    .campo-bloqueado {
        cursor: not-allowed;
        pointer-events: none;
        background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
        border-color: rgba(148, 163, 184, 0.4);
        color: #64748b;
        opacity: 0.75;
        user-select: none;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.06);
        position: relative;
    }

        .campo-bloqueado::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: repeating-linear-gradient( 45deg, transparent, transparent 8px, rgba(148, 163, 184, 0.08) 8px, rgba(148, 163, 184, 0.08) 16px );
            border-radius: 12px;
            pointer-events: none;
            opacity: 0.3;
        }

    .form-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        justify-content: flex-end;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

        .modern-btn:hover {
            transform: translateY(-2px);
        }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    }

    .modern-btn-light {
        background: linear-gradient(135deg, #e0f2fe 0%, #bfdbfe 100%);
        color: #1d4ed8;
        box-shadow: 0 8px 20px rgba(59, 130, 246, 0.18);
    }

    .modern-btn-danger {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
    }

    .divider {
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modern-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

        .modern-table .custom-table thead {
            background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        }

        .modern-table .custom-table th,
        .modern-table .custom-table td {
            padding: 14px 18px;
            border-bottom: 1px solid rgba(148, 163, 184, 0.16);
            font-size: 14px;
            color: #1e293b;
        }

        .modern-table .custom-table th {
            font-weight: 700;
            text-transform: uppercase;
            font-size: 12px;
            letter-spacing: 0.45px;
        }

        .modern-table .custom-table tbody tr:hover {
            background: rgba(59, 130, 246, 0.08);
        }

    .action-buttons {
        display: inline-flex;
        align-items: center;
        gap: 10px;
    }

    .action-btn {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid transparent;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: #f8fafc;
        color: #1f2937;
    }

        .action-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
        }

    .action-btn-view {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
    }

    .action-btn-delete {
        background: rgba(248, 113, 113, 0.12);
        color: #b91c1c;
        border-color: rgba(248, 113, 113, 0.35);
    }

        .action-btn-delete:hover {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: #ffffff;
            border-color: transparent;
        }

    .action-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: #ffffff;
        border-color: transparent;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
    }

        .action-btn-success:hover {
            background: linear-gradient(135deg, #059669 0%, #047857 100%);
            box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);
        }

        .action-btn-success:disabled {
            background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
            color: #ffffff;
            cursor: not-allowed;
            box-shadow: none;
            opacity: 0.7;
        }

    .action-btn-secondary {
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%);
        color: #ffffff;
        border-color: transparent;
        box-shadow: 0 4px 12px rgba(107, 114, 128, 0.3);
    }

        .action-btn-secondary:hover {
            background: linear-gradient(135deg, #4b5563 0%, #374151 100%);
            box-shadow: 0 6px 16px rgba(107, 114, 128, 0.4);
        }

        .action-btn-secondary:disabled {
            background: linear-gradient(135deg, #9ca3af 0%, #6b7280 100%);
            color: #ffffff;
            cursor: not-allowed;
            box-shadow: none;
            opacity: 0.7;
        }

    .empty-state {
        text-align: center;
        padding: 48px 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 12px;
    }

    .empty-icon {
        color: #cbd5e1;
    }

    .empty-title {
        margin: 0;
        font-size: 20px;
        font-weight: 700;
        color: #0f172a;
    }

    .empty-description {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .lote-header-container {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        flex-wrap: nowrap;
        overflow: hidden;
        padding-bottom: 4px;
    }

    .lote-scroll-wrapper {
        overflow-x: auto;
        flex-grow: 1;
    }

    .lote-scroll {
        display: flex;
        gap: 0.5rem;
        min-width: max-content;
        padding-bottom: 3px;
    }

    .lote-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 18px;
        padding: 14px 18px;
        border-radius: 14px;
        border: 1px solid rgba(148, 163, 184, 0.18);
        background: linear-gradient(135deg, rgba(239, 246, 255, 0.85) 0%, rgba(219, 234, 254, 0.85) 100%);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.8), 0 10px 24px rgba(37, 99, 235, 0.12);
        flex-wrap: wrap;
    }

    .lote-info {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 160px;
    }

    .lote-info-label {
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.3px;
        color: #2563eb;
    }

    .lote-info strong {
        font-size: 16px;
        font-weight: 700;
        color: #0f172a;
    }

    .lote-info-total {
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 12px 16px;
        border-radius: 10px;
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);
        border: 1px solid rgba(148, 163, 184, 0.25);
        box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
        margin-top: 8px;
    }

    .lote-info-total-label {
        font-size: 11px;
        text-transform: uppercase;
        font-weight: 600;
        letter-spacing: 0.3px;
        color: #64748b;
    }

    .lote-info-total-value {
        font-size: 18px;
        font-weight: 700;
        color: #0f172a;
        line-height: 1.2;
    }

    .lote-actions-buttons {
        display: inline-flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .lot-btn {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 18px;
        border-radius: 12px;
        font-weight: 600;
        font-size: 13px;
        letter-spacing: 0.2px;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.18);
    }

        .lot-btn svg {
            flex-shrink: 0;
        }

        .lot-btn:hover {
            transform: translateY(-2px);
        }

    .lot-btn-add {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
    }

    .lot-btn-remove {
        background: linear-gradient(135deg, #f87171 0%, #ef4444 100%);
        color: #ffffff;
    }

    .btn-lote {
        min-width: 120px;
        font-weight: 600;
        font-size: 14px;
        border-width: 2px;
        border-radius: 0.6rem;
        transition: all 0.2s ease-in-out;
        padding: 10px 16px;
        background: #ffffff;
        color: #1d4ed8;
        border-color: #bfdbfe;
    }

    .btn-lote-ativo {
        background-color: #2563EB;
        color: white;
        border-color: #2563EB;
        box-shadow: 0 0 0 0.2rem rgba(59, 130, 246, 0.25);
    }

    .border-danger {
        border-color: #e87986 !important;
        box-shadow: 0 0 0 0.18rem rgba(196, 104, 110, 0.25);
    }

    /* =========================
     *  ORIGIN BLOCK
     * ========================= */
    .origin-block {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.06) 0%, rgba(219, 234, 254, 0.12) 100%);
        border: 2px solid rgba(59, 130, 246, 0.2);
        border-radius: 16px;
        padding: 20px 24px;
        box-shadow: 0 8px 24px rgba(37, 99, 235, 0.08);
        transition: all 0.3s ease;
    }

        .origin-block:hover {
            box-shadow: 0 12px 32px rgba(37, 99, 235, 0.12);
            border-color: rgba(59, 130, 246, 0.3);
        }

    .origin-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 20px;
        flex-wrap: wrap;
    }

        .origin-top > div:first-child {
            flex: 1;
            min-width: 200px;
        }

    .origin-sub {
        font-size: 13px;
        color: #475569;
        margin-top: 4px;
        font-weight: 500;
    }

    .origin-switch {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: #ffffff;
        border-radius: 14px;
        padding: 6px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        box-shadow: 0 4px 12px rgba(15, 23, 42, 0.08);
    }

    .origin-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.2px;
        border: none;
        background: transparent;
        color: #64748b;
        cursor: pointer;
        transition: all 0.25s ease;
        position: relative;
        white-space: nowrap;
    }

        .origin-btn:hover {
            color: #2563eb;
            background: rgba(59, 130, 246, 0.08);
        }

        .origin-btn.active {
            background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
            color: #ffffff;
            box-shadow: 0 6px 18px rgba(37, 99, 235, 0.25);
        }

    /* =========================
     *  CATALOG PANEL
     * ========================= */
    .catalog-panel {
        background: linear-gradient(135deg, rgba(239, 246, 255, 0.6) 0%, rgba(219, 234, 254, 0.6) 100%);
        border: 2px dashed rgba(59, 130, 246, 0.3);
        border-radius: 16px;
        padding: 22px 26px;
        animation: fadeIn 0.3s ease;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(-8px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .catalog-row {
        margin-bottom: 16px;
    }

    .catalog-option {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

        .catalog-option strong {
            font-weight: 700;
            color: #0f172a;
            font-size: 14px;
        }

        .catalog-option .text-muted {
            font-size: 13px;
            color: #64748b;
        }

    .catalog-selected {
        display: flex;
        align-items: center;
        gap: 8px;
    }

        .catalog-selected strong {
            font-weight: 700;
            color: #0f172a;
            font-size: 14px;
        }

        .catalog-selected .text-muted {
            font-size: 13px;
            color: #64748b;
        }

    /* =========================
     *  V-SELECT STYLES
     * ========================= */
    :deep(.v-select) {
        position: relative;
    }

    :deep(.v-select .vs__dropdown-toggle) {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        background: #ffffff;
        padding: 10px 14px;
        min-height: 48px;
        transition: all 0.2s ease;
    }

    :deep(.v-select .vs__dropdown-toggle:hover) {
        border-color: rgba(59, 130, 246, 0.4);
    }

    :deep(.v-select .vs__dropdown-toggle:focus-within) {
        border-color: rgba(37, 99, 235, 0.6);
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.12);
    }

    :deep(.v-select .vs__selected-options) {
        padding: 0;
    }

    :deep(.v-select .vs__search::placeholder) {
        color: #94a3b8;
        font-size: 14px;
    }

    :deep(.v-select .vs__search) {
        font-size: 14px;
        color: #1f2937;
        padding: 0;
        margin: 0;
        border: none;
        outline: none;
    }

    :deep(.v-select .vs__actions) {
        padding: 0;
        padding-left: 8px;
    }

    :deep(.v-select .vs__clear) {
        fill: #94a3b8;
        margin-right: 8px;
        cursor: pointer;
        transition: fill 0.2s ease;
    }

    :deep(.v-select .vs__clear:hover) {
        fill: #ef4444;
    }

    :deep(.v-select .vs__open-indicator) {
        fill: #94a3b8;
        transform: scale(0.9);
        transition: transform 0.2s ease, fill 0.2s ease;
    }

    :deep(.v-select.vs--open .vs__open-indicator) {
        transform: scale(0.9) rotate(180deg);
        fill: #2563eb;
    }

    :deep(.v-select .vs__dropdown-menu) {
        border-radius: 12px;
        border: 2px solid rgba(148, 163, 184, 0.25);
        box-shadow: 0 12px 32px rgba(15, 23, 42, 0.15);
        margin-top: 6px;
        background: #ffffff;
        max-height: 300px;
        overflow-y: auto;
        padding: 8px 0;
        z-index: 9999 !important;
        position: absolute !important;
        z-index: 30000 !important;
    }

    /* Garantir que o dropdown apareça acima da modal */
    :deep(body > .vs__dropdown-menu) {
        z-index: 1060 !important;
        position: fixed !important;
    }

    /* Quando o v-select está aberto dentro de uma modal */
    :deep(.modal.show .v-select.vs--open .vs__dropdown-menu),
    :deep(.modal.show .vs__dropdown-menu),
    :deep(.modal.fade.show .vs__dropdown-menu) {
        z-index: 1060 !important;
    }

    :deep(.v-select .vs__dropdown-option) {
        padding: 12px 18px;
        color: #1f2937;
        font-size: 14px;
        transition: all 0.2s ease;
        cursor: pointer;
    }

    :deep(.v-select .vs__dropdown-option:hover) {
        background: rgba(59, 130, 246, 0.1);
        color: #2563eb;
    }

    :deep(.v-select .vs__dropdown-option--highlight) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.15) 0%, rgba(59, 130, 246, 0.1) 100%);
        color: #1d4ed8;
        font-weight: 600;
    }

    :deep(.v-select .vs__no-options) {
        padding: 16px 18px;
        color: #64748b;
        font-size: 13px;
        text-align: center;
    }

    :deep(.v-select .vs__spinner) {
        border-top-color: #2563eb;
        border-right-color: #2563eb;
    }

    :deep(.v-select .vs__loading) {
        padding: 16px 18px;
        color: #64748b;
        font-size: 13px;
        text-align: center;
    }

    @media (max-width: 992px) {
        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
        }

        .header-actions {
            justify-content: flex-start;
        }
    }

    @media (max-width: 768px) {
        .modal-dialog.modal-grande {
            max-width: 100% !important;
            margin: 0;
            margin-top: 20px;
        }

        .modal-modern-body {
            padding: 24px 20px 32px;
        }

        .form-section,
        .table-section {
            padding: 24px;
        }

        .modal-body-unidade {
            padding: 22px 20px 28px;
        }

        .helper-box {
            flex-direction: column;
            align-items: flex-start;
        }

        .form-columns {
            grid-template-columns: 1fr;
            gap: 24px;
        }

        .section-header-row {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
        }

        .lote-total-box {
            align-items: flex-start;
            width: 100%;
        }

        .form-row {
            grid-template-columns: 1fr;
        }

        .form-actions {
            justify-content: center;
        }

        .origin-top {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
        }

        .origin-switch {
            width: 100%;
            justify-content: stretch;
        }

        .origin-btn {
            flex: 1;
        }

        .catalog-panel {
            padding: 18px 20px;
        }

        .lote-actions {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .lote-actions-buttons {
            justify-content: stretch;
        }

            .lote-actions-buttons .lot-btn {
                width: 100%;
                justify-content: center;
            }

        .lote-header-container {
            flex-direction: column;
            align-items: stretch;
        }

        .modern-table .custom-table,
        .modern-table .custom-table thead,
        .modern-table .custom-table tbody,
        .modern-table .custom-table th,
        .modern-table .custom-table td,
        .modern-table .custom-table tr {
            display: block;
            width: 100%;
        }

            .modern-table .custom-table thead {
                display: none;
            }

            .modern-table .custom-table tr {
                margin-bottom: 16px;
                border-radius: 14px;
                overflow: hidden;
                box-shadow: 0 4px 14px rgba(15, 23, 42, 0.08);
            }

            .modern-table .custom-table td {
                border: none;
                border-bottom: 1px solid rgba(148, 163, 184, 0.15);
                padding: 14px 16px;
                text-align: left !important;
            }

                .modern-table .custom-table td:last-child {
                    border-bottom: none;
                }

                .modern-table .custom-table td::before {
                    content: attr(data-label);
                    display: block;
                    font-weight: 700;
                    margin-bottom: 6px;
                    text-transform: uppercase;
                    color: #64748b;
                    font-size: 12px;
                }
    }

    :deep([data-bs-theme="dark"] .modern-modal .modal-modern-content) {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    :deep([data-bs-theme="dark"] .modern-modal .modal-modern-header::after) {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    :deep([data-bs-theme="dark"] .modern-modal .header-icon) {
        background: linear-gradient(135deg, rgba(16, 185, 129, 0.26) 0%, rgba(59, 130, 246, 0.26) 100%);
        color: #34d399;
    }

    :deep([data-bs-theme="dark"] .modern-modal .header-text h2) {
        color: #f8fafc;
    }

    :deep([data-bs-theme="dark"] .modern-modal .header-text p) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .modern-modal .form-section),
    :deep([data-bs-theme="dark"] .modern-modal .table-section) {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.15);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
    }

    :deep([data-bs-theme="dark"] .modern-modal .modal-body-unidade) {
        background: transparent;
    }

    :deep([data-bs-theme="dark"] .modern-modal .helper-box) {
        background: rgba(59, 130, 246, 0.18);
        border-color: rgba(59, 130, 246, 0.35);
        color: #bfdbfe;
    }

    :deep([data-bs-theme="dark"] .modern-modal .periodicidade-switch) {
        background: rgba(15, 23, 42, 0.85);
        border-color: rgba(148, 163, 184, 0.2);
    }

    :deep([data-bs-theme="dark"] .modern-modal .periodicidade-switch .form-check-label) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .periodicidade-hint) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-actions) {
        background: linear-gradient(135deg, rgba(30, 64, 175, 0.35) 0%, rgba(17, 24, 39, 0.7) 100%);
        border-color: rgba(59, 130, 246, 0.22);
        box-shadow: inset 0 1px 0 rgba(148, 163, 184, 0.12), 0 12px 32px rgba(15, 23, 42, 0.45);
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-info-label) {
        color: #93c5fd;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-info strong) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-total-box) {
        background: linear-gradient(135deg, rgba(30, 64, 175, 0.35) 0%, rgba(17, 24, 39, 0.7) 100%);
        border-color: rgba(59, 130, 246, 0.22);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-total-label) {
        color: #93c5fd;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-total-value) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-info-total) {
        background: linear-gradient(135deg, rgba(30, 41, 59, 0.8) 0%, rgba(15, 23, 42, 0.9) 100%);
        border-color: rgba(148, 163, 184, 0.2);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-info-total-label) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lote-info-total-value) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .lot-btn) {
        box-shadow: 0 12px 30px rgba(15, 23, 42, 0.6);
    }

    :deep([data-bs-theme="dark"] .modern-modal .form-control) {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .modern-modal .form-control:focus) {
        border-color: rgba(59, 130, 246, 0.6);
        box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
    }

    :deep([data-bs-theme="dark"] .modern-modal .form-control:disabled),
    :deep([data-bs-theme="dark"] .modern-modal .form-control[disabled]) {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.5) 0%, rgba(30, 41, 59, 0.6) 100%);
        border-color: rgba(148, 163, 184, 0.25);
        color: #64748b;
        cursor: not-allowed;
        opacity: 0.6;
        user-select: none;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    :deep([data-bs-theme="dark"] .modern-modal .form-control:disabled::before),
    :deep([data-bs-theme="dark"] .modern-modal .form-control[disabled]::before) {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: repeating-linear-gradient( 45deg, transparent, transparent 8px, rgba(148, 163, 184, 0.1) 8px, rgba(148, 163, 184, 0.1) 16px );
        border-radius: 12px;
        pointer-events: none;
        opacity: 0.4;
    }

    :deep([data-bs-theme="dark"] .modern-modal .form-control:disabled:focus),
    :deep([data-bs-theme="dark"] .modern-modal .form-control[disabled]:focus) {
        border-color: rgba(148, 163, 184, 0.25);
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    :deep([data-bs-theme="dark"] .modern-modal select.form-control:disabled),
    :deep([data-bs-theme="dark"] .modern-modal select.form-control[disabled]) {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2364748B' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round' opacity='0.5'/%3E%3C/svg%3E");
    }

    :deep([data-bs-theme="dark"] .modern-modal .campo-bloqueado) {
        background: linear-gradient(135deg, rgba(15, 23, 42, 0.5) 0%, rgba(30, 41, 59, 0.6) 100%);
        border-color: rgba(148, 163, 184, 0.25);
        color: #64748b;
        opacity: 0.6;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    :deep([data-bs-theme="dark"] .modern-modal .campo-bloqueado::before) {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: repeating-linear-gradient( 45deg, transparent, transparent 8px, rgba(148, 163, 184, 0.1) 8px, rgba(148, 163, 184, 0.1) 16px );
        border-radius: 12px;
        pointer-events: none;
        opacity: 0.4;
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-input-group .input-group-text) {
        background: rgba(59, 130, 246, 0.18);
        color: #cbd5f5;
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-btn-light) {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        color: #e0f2fe;
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-table .custom-table) {
        border-color: rgba(148, 163, 184, 0.18);
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-table .custom-table thead) {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-table .custom-table th),
    :deep([data-bs-theme="dark"] .modern-modal .modern-table .custom-table td) {
        color: #e2e8f0;
        border-color: rgba(148, 163, 184, 0.15);
    }

    :deep([data-bs-theme="dark"] .modern-modal .modern-table .custom-table tbody tr:hover) {
        background: rgba(59, 130, 246, 0.18);
    }

    :deep([data-bs-theme="dark"] .modern-modal select.form-control) {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    /* Dark mode para origin-block */
    :deep([data-bs-theme="dark"] .origin-block) {
        background: linear-gradient(135deg, rgba(30, 64, 175, 0.25) 0%, rgba(17, 24, 39, 0.5) 100%);
        border-color: rgba(59, 130, 246, 0.3);
    }

    :deep([data-bs-theme="dark"] .origin-sub) {
        color: #94a3b8;
    }

    :deep([data-bs-theme="dark"] .origin-switch) {
        background: rgba(15, 23, 42, 0.9);
        border-color: rgba(148, 163, 184, 0.2);
    }

    :deep([data-bs-theme="dark"] .origin-btn) {
        color: #cbd5e1;
    }

    :deep([data-bs-theme="dark"] .origin-btn:hover) {
        color: #60a5fa;
        background: rgba(59, 130, 246, 0.2);
    }

    :deep([data-bs-theme="dark"] .origin-btn.active) {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
    }

    :deep([data-bs-theme="dark"] .catalog-panel) {
        background: linear-gradient(135deg, rgba(30, 64, 175, 0.2) 0%, rgba(17, 24, 39, 0.4) 100%);
        border-color: rgba(59, 130, 246, 0.35);
    }

    /* Dark mode para v-select */
    :deep([data-bs-theme="dark"] .v-select .vs__dropdown-toggle) {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .v-select .vs__search) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .v-select .vs__search::placeholder) {
        color: #64748b;
    }

    :deep([data-bs-theme="dark"] .v-select .vs__dropdown-menu) {
        background: rgba(15, 23, 42, 0.95);
        border-color: rgba(148, 163, 184, 0.2);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.5);
        z-index: 1060 !important;
    }

    :deep([data-bs-theme="dark"] body > .vs__dropdown-menu) {
        z-index: 1060 !important;
    }

    :deep([data-bs-theme="dark"] .v-select .vs__dropdown-option) {
        color: #e2e8f0;
    }

    :deep([data-bs-theme="dark"] .v-select .vs__dropdown-option:hover) {
        background: rgba(59, 130, 246, 0.2);
        color: #60a5fa;
    }

    :deep([data-bs-theme="dark"] .v-select .vs__dropdown-option--highlight) {
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.3) 0%, rgba(59, 130, 246, 0.2) 100%);
        color: #93c5fd;
    }

    :deep([data-bs-theme="dark"] .catalog-option strong),
    :deep([data-bs-theme="dark"] .catalog-selected strong) {
        color: #f8fafc;
    }

    :deep([data-bs-theme="dark"] .catalog-option .text-muted),
    :deep([data-bs-theme="dark"] .catalog-selected .text-muted) {
        color: #94a3b8;
    }
</style>
